<ui-dialog
    [open]="currentlyOpenDialog === 'ADD_OFFICE'"
    [form]="officeForm.form"
    header="company.offices.addOfficeDialogHeader"
    size="small"
    (primaryButtonPressed)="onCreate(officeForm.office, officeForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel()"
    (closing)="onCancel()"
    secondaryButtonLabel="cancel"
>
    <app-office-form #officeForm></app-office-form>
</ui-dialog>

<ui-confirmation-dialog
    #confirmMakePrimary
    header="company.offices.setPrimaryOfficeDialogHeader"
    primaryButtonLabel="confirm"
    secondaryButtonLabel="cancel"
>
    {{ 'company.offices.setPrimaryOfficeDialogMessage' | translate }}
</ui-confirmation-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-header title="{{ 'company.offices.header' | translate }}" [menuService]="companyMenuService">
        <div class="buttons">
            <ng-container *permission="'create.companyAddress'">
                <ui-button (click)="currentlyOpenDialog = 'ADD_OFFICE'" type="primary">
                    <mat-icon svgIcon="plus"></mat-icon>
                    {{ 'company.offices.createOfficeButton' | translate }}
                </ui-button>
            </ng-container>
        </div>
    </app-header>

    <div *ngIf="showMap" class="ui google raised segment" [class.loading]="_googleImage === '' && !isLoading">
        <img [attr.src]="_googleImage" />
    </div>

    <app-table [table]="table" [useStickyHeader]="false" class="table" (menuItemSelected)="menuAction($event)">
        <app-empty-state label="company.offices.noOfficesFoundMessage"></app-empty-state>
    </app-table>
</div>
